export default {
    gifts (state) {
      return state.gifts
    },

    selectedGift (state) {
        return state.selectedGift
    },

    getGift: state => (id) => {
      return state.gifts.find(item => item.userGiftId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/gifts/getters.js